const updateOrderItemImage = ({
  orderItems,
  oidIndex,
  sku,
  content,
  target,
}) => {
  const currentOrderItems = orderItems
  currentOrderItems[`${oidIndex(sku)}`].images = [
    ...(currentOrderItems[`${oidIndex(sku)}`].images || []).filter(x => x.id !== target.id),
    { id: target.id, type: content.type },
  ]
}

export default updateOrderItemImage
